import { useCallback } from 'react';
import { useActiveProjectId } from '@frameio/shared/contexts';
import {
  useAssetClipboard,
  useClearAssetClipboard,
  useCopyAssetsWithWarning,
  useMoveAssetsWithWarning,
} from '../../operations/contexts';

export const usePasteAssetClipboard = () => {
  const clipboard = useAssetClipboard();
  const projectId = useActiveProjectId();
  const copyAssetsWithWarning = useCopyAssetsWithWarning();
  const moveAssetsWithWarning = useMoveAssetsWithWarning();
  const clearClipboard = useClearAssetClipboard();

  return useCallback(
    (destinationFolderId: string) => {
      if (clipboard.assetIds.length === 0) return;

      if (clipboard.operation === 'cut') {
        if (!clipboard.sourceFolderId) {
          return;
        }

        // if cut & paste into the same folder, it's a no-op and we simply
        // clear the clipboard contents
        if (clipboard.sourceFolderId === destinationFolderId) {
          return;
        }

        moveAssetsWithWarning({
          assetIds: clipboard.assetIds,
          destination: {
            id: destinationFolderId,
            project: { id: projectId },
          },
          sourceId: clipboard.sourceFolderId,
        });

        clearClipboard();
      } else {
        copyAssetsWithWarning({
          assetIds: clipboard.assetIds,
          destination: {
            id: destinationFolderId,
            project: { id: projectId },
          },
          duplicate: destinationFolderId === clipboard.sourceFolderId,
          forceRefetch: true,
        });
      }
    },
    [
      clipboard,
      projectId,
      copyAssetsWithWarning,
      moveAssetsWithWarning,
      clearClipboard,
    ]
  );
};
